import * as React from "react";

function SvgSun(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" height="19" width="19"
      {...props}
    >
      <path
        data-name="Path 43791 - Outline"
        d="M480-360q50 0 85-35t35-85q0-50-35-85t-85-35q-50 0-85 35t-35 85q0 50 35 85t85 35Zm0 80q-83 0-141.5-58.5T280-480q0-83 58.5-141.5T480-680q83 0 141.5 58.5T680-480q0 83-58.5 141.5T480-280ZM200-440H40v-80h160v80Zm720 0H760v-80h160v80ZM440-760v-160h80v160h-80Zm0 720v-160h80v160h-80ZM256-650l-101-97 57-59 96 100-52 56Zm492 496-97-101 53-55 101 97-57 59Zm-98-550 97-101 59 57-100 96-56-52ZM154-212l101-97 55 53-97 101-59-57Zm326-268Z"
        fill="#ffffff"
        stroke="#fff"
        strokeWidth={0.5}
      />
    </svg>
  );
}

export default SvgSun;
